class EmployeeSubscribedToMonthlyBenefitSystemNotificationPayload {
  constructor() {}
}

export default EmployeeSubscribedToMonthlyBenefitSystemNotificationPayload;
